import api from './models/AxiosConfig';
import APIResponse from './models/APIResponse';
import ServiceUtil from './serviceUtil';

const utilService = new ServiceUtil();

class ServiceAPI {
    doCall(uri, body, token) { };
}

class GetAPIService extends ServiceAPI {
    async doCall(uri, body, token) {
        var requestHeaders = {
            'Content-type': 'application/json',
            'Accept': 'application/json',
        };
        const storedCookies = await utilService.getStoredCookies();
        if (storedCookies.isNotEmpty) {
            requestHeaders['cookie'] =
                storedCookies.entries.map((e) => '${e.key}=${e.value}').join('; ');
        }
        var response = await api.get(uri, { headers: requestHeaders, withCredentials: true });
        var main = response.data;
        return new APIResponse(
            main["data"],
            main["status"],
            main["statuscode"],
            main["msg"],
        );
    }
}

class PostAPIService extends ServiceAPI {
    async doCall(uri, body, token) {
        var requestHeaders = {
            'Content-type': 'application/json',
            'Accept': 'application/json',
        };
        const storedCookies = await utilService.getStoredCookies();
        if (storedCookies.isNotEmpty) {
            requestHeaders['cookie'] =
                storedCookies.entries.map((e) => '${e.key}=${e.value}').join('; ');
        }
        var response = await api.post(uri, body, { headers: requestHeaders, withCredentials: true });
        var main = response.data;
        return new APIResponse(
            main["data"],
            main["status"],
            main["statuscode"],
            main["msg"],
        );
    }
}

class CustomeAPIService extends ServiceAPI {
    async doCall(uri, body, headers) {
        var requestHeaders = headers;
        var response = await api.post(uri, body, { headers: requestHeaders, withCredentials: true });
        var main = response.data;
        return new APIResponse(
            main["data"],
            main["status"],
            main["statuscode"],
            main["msg"],
        );
    }
}

export default class APIServiceLookUp {
    getAPIService(serviceType) {
        if (serviceType === "GET") {
            return new GetAPIService();
        } else if (serviceType === "CUST") {
            return new CustomeAPIService();
        } else {
            return new PostAPIService();
        }
    }
}